export const htmlContent = `
<html>
    <head>
        <title>Print Content</title>
        <style>
            body {
              margin: 0;
              padding: 0;
              border: 0;
            }
            @font-face {
              font-family: 'Code128';
              src: url('/fonts/code128.ttf') format('truetype');
            }
            .container {
              width: 33.33%; /* 3 barcodes per line */
              height: 12.5%; /* 100% divided by 8 rows = 12.5% per barcode */
              float: left;
              box-sizing: border-box;
              padding: 10px 0; /* A bit of padding to ensure the barcode is nicely centered */
              overflow: hidden; /* In case the content exceeds the box size */
            }
            .barcode {
              font-family: 'Code128', sans-serif;
              text-align: center;
              font-size: 56px;
            }
            .details {
              text-align: center;
            }
        </style>
    </head>
    <body>
        <%barcodesHTML%>
    </body>
</html>
`;

export const sampleHTML = `
<div class="container">
    <div class="barcode"><%formattedBarcode%></div>
    <div class="details"><%barcode%></div>
    <div style="margin: 0 20px; display: flex; justify-content: space-between;">
        <div><%laboratoryName%></div>
        <div><%refLabel%>: <%ref%></div>
    </div>
    <div style="margin: 0 20px; display: flex; justify-content: space-between;">
        <div><%samplingDateLabel%>: <%samplingDate%></div>
        <div><%size%><%sizeUnit%></div>
    </div>
</div>
`;
